module.exports = __webpack_public_path__ + "static/business-idea-934e573f594a075c0fc47bebf0c95ba5.png";